// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"796c424c","110":"cb8adcf5","295":"0a85a85f","412":"c05380d1","544":"6a961826","665":"b3bc614e"}[chunkId] + ".chunk.js";
};